import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import HubsEntityCollection from '../../../../../components/HubsEntityCollection';
import MonthDayField from '../../../../../components/MonthDayField';
import FeatureEnabled from '../../../../../components/FeatureEnabled';
import FeatureDisabled from '../../../../../components/FeatureDisabled';
import Icon from '../../../../../components/Icon';
import messages from '../messages';
import * as constants from '../../../../Authorization/constants';
import '../styles.css';

export const EntityComponent = (props) => (
  <React.Fragment>

    <FeatureEnabled allOf={constants.COMMON_APP_DEADLINES}>
      <MonthDayFieldWrapper {...props} disabled={props.entity.isCommonApp} />
    </FeatureEnabled>

    <FeatureDisabled anyOf={constants.COMMON_APP_DEADLINES}>
      <MonthDayFieldWrapper {...props} />
    </FeatureDisabled>

    <DeadlineWarning isCommonApp={props.entity.isCommonApp} />

  </React.Fragment>
);

export const MonthDayFieldWrapper = ({ entity, collection, handleChange, order, disabled }) => (
  <MonthDayField
    initialValue={{ day: entity.day, month: entity.month }}
    disabled={disabled}
    onChange={(type, value) => handleChange(null, {
      value: value[type],
      order,
      name: type,
      typeName: get(collection, 'editor.cmsDataMapping.deadlineTypes', {})[entity.type],
    }, null, order)}
  />
);

const DeadlineWarning = ({ isCommonApp }) => !!isCommonApp && (
  <div data-cy="deadline-warning">
    <FeatureEnabled allOf={constants.COMMON_APP_DEADLINES}>
      <div styleName="deadline-warning">
        <Icon size="large" name="info circle" />
        <FormattedMessage {...messages.deadlineWarning} />
      </div>
    </FeatureEnabled>
  </div>
);

DeadlineWarning.propTypes = {
  isCommonApp: PropTypes.bool,
};

EntityComponent.propTypes = {
  entity: PropTypes.object,
  handleChange: PropTypes.func,
  order: PropTypes.number,
  collection: PropTypes.object,
};

MonthDayFieldWrapper.propTypes = {
  entity: PropTypes.object,
  handleChange: PropTypes.func,
  order: PropTypes.number,
  collection: PropTypes.object,
  disabled: PropTypes.bool,
};

const Deadlines = ({ onChange, ...props }) => (
  <HubsEntityCollection
    {...props}
    disableRemove
    nonUnique
    _key="he_deadlinetype"
  >
    <EntityComponent handleChange={onChange} />
  </HubsEntityCollection>
);

Deadlines.propTypes = {
  initialValue: PropTypes.array,
  onChange: PropTypes.func,
  mapper: PropTypes.object,
};

export default Deadlines;
